import { TransactionStep } from "@models/transaction";

export type Step = TransactionStep;

export const StepOrder: Step[] = [
  "INIT",
  "CARD_CAPTURED",
  "DATA_STRUCTURED",
  "ISO_BUILT",
  "ENCRYPTED",
  "ROUTED",
  "AUTHORIZED",
  "COMPLETED"
];

export function getNextStep(current: Step): Step | null {
  const idx = StepOrder.indexOf(current);
  if (idx === -1 || idx === StepOrder.length - 1) return null;
  return StepOrder[idx + 1];
}